import { LOG_OUT_REGISTRANT_SUCCESS } from '../registrantLogin/actionTypes';
import { INITIATE_CANCEL_REGISTRATION_SUCCESS } from '../registrationForm/regCart/actionTypes';
import {
  RESTORE_TRAVEL_CART, UPDATE_TRAVEL_CART_SUCCESS, TRAVEL_CART_NOT_FOUND, SET_SELECTED_AIR_ACTUAL_ID,
  SET_SELECTED_AIR_REQUEST_ID, SET_AIR_REQUEST_SUMMARY_VIEW, SET_AIR_ACTUAL_SUMMARY_VIEW, CLEAR_USER_SESSION_DATA,
  TOGGLE_OWN_AIR_TRAVEL_RESERVATION, TOGGLE_OWN_HOTEL_ACCOMMODATION, UPDATE_CREDIT_CARD, SET_EXPANDED_HOTELS,
  SET_ANOTHER_HOTEL_REQUEST, SET_HOTEL_REQUEST_SUMMARY_VIEW, RESET_USER_SESSION_TRAVEL_DATA
} from './actionTypes';

const initialState = {
  cart: {
    bookings: []
  },
  isCartCreated: false,
  userSession: {
    airRequest: { ownBooking: false, showSummary: true, selectedAirRequestIds: [] },
    hotelRequest: { ownBooking: false, isSummaryView: false, expandedHotels: [], isMakingAnotherRequest: false },
    creditCard: null,
    airActual: { showSummary: true, selectedAirActualIds: [] }
  }
};

export default function reducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case RESTORE_TRAVEL_CART:
      return { ...payload } || { ...initialState };
    case UPDATE_TRAVEL_CART_SUCCESS:
      return {
        ...state,
        cart: {
          ...payload.travelCart
        },
        isCartCreated: true
      };
    case TRAVEL_CART_NOT_FOUND:
      return {
        ...state,
        cart: {
          id: payload.travelCartId
        },
        isCartCreated: false
      };
    case SET_SELECTED_AIR_REQUEST_ID:
      return {
        ...state,
        userSession: {
          ...state.userSession,
          airRequest: {
            ...state.userSession.airRequest,
            selectedAirRequestIds: payload.selectedAirRequestIds
          }
        }
      };
    case SET_SELECTED_AIR_ACTUAL_ID:
      return {
        ...state,
        userSession: {
          ...state.userSession,
          airActual: {
            ...state.userSession.airActual,
            selectedAirActualIds: payload.selectedAirActualIds
          }
        }
      };
    case SET_AIR_REQUEST_SUMMARY_VIEW:
      return {
        ...state,
        userSession: {
          ...state.userSession,
          airRequest: {
            ...state.userSession.airRequest,
            showSummary: payload.showSummary
          }
        }
      };
    case SET_AIR_ACTUAL_SUMMARY_VIEW:
      return {
        ...state,
        userSession: {
          ...state.userSession,
          airActual: {
            ...state.userSession.airActual,
            showSummary: payload.showSummary
          }
        }
      };
    case CLEAR_USER_SESSION_DATA:
      return {
        ...state,
        userSession: { ...initialState.userSession }
      };
    case TOGGLE_OWN_AIR_TRAVEL_RESERVATION: {
      const userSession = !state.userSession.airRequest.ownBooking ? {
        ...state.userSession,
        airRequest: {
          ...state.userSession.airRequest,
          ownBooking: true,
          showSummary: true
        }
      } : {
        ...state.userSession,
        airRequest: {
          ...state.userSession.airRequest,
          ownBooking: false
        }
      };
      return {
        ...state,
        userSession
      };
    }
    case TOGGLE_OWN_HOTEL_ACCOMMODATION:
      return {
        ...state,
        userSession: {
          ...state.userSession,
          // reset hotel request view to hotel request
          hotelRequest: {
            ...state.userSession.hotelRequest,
            ownBooking: !state.userSession.hotelRequest.ownBooking,
            isSummaryView: false,
            expandedHotels: [],
            isMakingAnotherRequest: false
          }
        }
      };
    case SET_HOTEL_REQUEST_SUMMARY_VIEW:
      return {
        ...state,
        userSession: {
          ...state.userSession,
          hotelRequest: {
            ...state.userSession.hotelRequest,
            isSummaryView: payload.showSummary
          }
        }
      };
    case SET_EXPANDED_HOTELS:
      return {
        ...state,
        userSession: {
          ...state.userSession,
          hotelRequest: {
            ...state.userSession.hotelRequest,
            expandedHotels: payload.expandedHotels
          }
        }
      };
    case SET_ANOTHER_HOTEL_REQUEST:
      return {
        ...state,
        userSession: {
          ...state.userSession,
          hotelRequest: {
            ...state.userSession.hotelRequest,
            isMakingAnotherRequest: payload.isMakingAnotherRequest
          }
        }
      };
    case RESET_USER_SESSION_TRAVEL_DATA:
      return {
        ...state,
        userSession: {
          ...state.userSession,
          hotelRequest: {
            ...state.userSession.hotelRequest,
            isSummaryView: false,
            expandedHotels: [],
            isMakingAnotherRequest: false
          },
          airRequest: {
            ...state.userSession.airRequest,
            showSummary: true
          },
          airActual: {
            ...state.userSession.airActual,
            showSummary: true
          }
        }
      };
    case LOG_OUT_REGISTRANT_SUCCESS: // invitee logs out
    case INITIATE_CANCEL_REGISTRATION_SUCCESS: // invitee cancels reg
      return initialState;
    case UPDATE_CREDIT_CARD:
      return {
        ...state,
        userSession: {
          ...state.userSession,
          creditCard: payload.creditCard ? {
            ...payload.creditCard
          } : null
        }
      };
    default:
      return state;
  }
}
